import iconLift from './img/optionsImages/icon-lift.png';
import iconHeart from './img/optionsImages/icon-heart.png';
import iconScales from './img/optionsImages/icon-scales.png';
import iconMuscle from './img/optionsImages/icon-muscle.png';
import iconFlexFemale from './img/optionsImages/iconFlex_female.png';
import iconFlexMale from './img/optionsImages/iconFlex_male.png';
import iconRunFemale from './img/optionsImages/iconRun_female.png';
import iconRunMale from './img/optionsImages/iconRun_male.png';
import iconHome from './img/optionsImages/icon-home.png';
import iconWalking from './img/optionsImages/icon-walking.png';
import iconRuning from './img/optionsImages/icon-running.png';
import iconYoga from './img/optionsImages/icon-yoga.png';
import iconDance from './img/optionsImages/icon-dance.png';
import iconTips from './img/optionsImages/icon-tips.png';
import iconOk from './img/optionsImages/icon-seeing.png';
import iconTraining from './img/optionsImages/icon-training.png';
import iconGlobe from './img/optionsImages/icon-supportive.png';
import iconReceipt from './img/optionsImages/icon-guidelines.png';
import iconTrafficLight from './img/optionsImages/icon-applerings.png';
import iconMeat from './img/optionsImages/icon-food.png';
import iconVeget from './img/optionsImages/icon-veget.png';
import iconVegan from './img/optionsImages/icon-vegan.png';
import iconCheese from './img/optionsImages/icon-keto.png';
import absCore from './img/optionsImages/abs_core.png';
import armBack from './img/optionsImages/arm_back.png';
import legsGlutes from './img/optionsImages/legs_glutes.png';
import absCoreMale from './img/optionsImages/abs_core_male.png';
import armBackMale from './img/optionsImages/arm_back_male.png';
import legsGlutesMale from './img/optionsImages/legs_glutes_male.png';
import time0 from './img/optionsImages/icon-maximum.png';
import time1 from './img/optionsImages/icon-minimum.png';
import time2 from './img/optionsImages/icon-normal.png';
import time3 from './img/optionsImages/icon-vervdecide.png';
import bed from './img/optionsImages/bed.png';
import sleep from './img/optionsImages/sleep.png';
import sleep2 from './img/optionsImages/sleep2.png';
import superhero from './img/optionsImages/superhero.png';
import coffee from './img/optionsImages/coffee.png';
import horns from './img/optionsImages/horns.png';
import ok from './img/optionsImages/ok.png';
import two from './img/optionsImages/two.png';
import fire from './img/optionsImages/fire.png';
import thinking from './img/optionsImages/thinking.png';
import cross from './img/optionsImages/cross.png';
import laugh from './img/optionsImages/laugh.png';
import relievedFace from './img/optionsImages/relieved-face.png';
import starsEyes from './img/optionsImages/stars-eyes.png';
import facepalm from './img/optionsImages/facepalm.png';
import frowningFace from './img/optionsImages/frowning-face.png';
import iconAlembic from './img/optionsImages/icon_alembic.png';
import iconBreath from './img/optionsImages/icon_breath.png';
import iconComputer from './img/optionsImages/icon_computer.png';
import iconCurryRice from './img/optionsImages/icon_curry-rice.png';
import iconDna from './img/optionsImages/icon_dna.png';
import iconDontNow from './img/optionsImages/icon_dont_now.png';
import iconDrop from './img/optionsImages/icon_drop.png';
import iconJoint from './img/optionsImages/icon_joint.png';
import iconMoon from './img/optionsImages/icon_moon.png';
import iconPill from './img/optionsImages/icon_pill.png';
import iconPlateAndForks from './img/optionsImages/icon_plate_and_forks.png';
import iconReceiptTwo from './img/optionsImages/icon_receipt.png';
import iconRocket from './img/optionsImages/icon_rocket.png';
import iconRunning from './img/optionsImages/icon_running.png';
import iconSmile from './img/optionsImages/icon_smile.png';
import iconSun from './img/optionsImages/icon_sun.png';
import iconTestTube from './img/optionsImages/icon_test_tube.png';
import iconWalkingTwo from './img/optionsImages/icon_walking.png';
import iconYogaTwo from './img/optionsImages/icon_yoga.png';
import smileGlasses from './img/optionsImages/smileGlasses.png';
import apple from './img/optionsImages/appleBody.png';
import hourglass from './img/optionsImages/hourglass.png';
import pear from './img/optionsImages/pear.png';
import square from './img/optionsImages/square.png';
import trapezoid from './img/optionsImages/trapezoid.svg';
import triangle from './img/optionsImages/triangle.png';
import unknown from './img/optionsImages/unknown-female.png';
import appleMale from './img/optionsImages/appleBodyMale.png';
import pearMale from './img/optionsImages/pearMale.png';
import squareMale from './img/optionsImages/squareMale.png';
import trapezoidMale from './img/optionsImages/trapezoidMale.png';
import triangleMale from './img/optionsImages/triangleMale.png';
import unknownMale from './img/optionsImages/unknown-male.png';
import fitness from './img/optionsImages/fitness.svg';
import barbell from './img/optionsImages/barbell.png';
import treadmill from './img/optionsImages/treadmill.svg';
import dumbells from './img/optionsImages/dumbells.png';
import appleGreen from './img/optionsImages/apple.png';
import trueImg from './img/optionsImages/true.svg';
import falseImg from './img/optionsImages/false.svg';
import abs from './img/optionsImages/zones_abs.png';
import glutes from './img/optionsImages/zones_glutes.png';
import armpits from './img/optionsImages/zones_armpits.png';
import thighs from './img/optionsImages/zones_thighs.png';
import coloredToneUp from './img/optionsImages/colored_toneUp.png';
import coloredHeart from './img/optionsImages/colored_heart.png';
import coloredGain from './img/optionsImages/colored_gain.png';
import coloredScales from './img/optionsImages/colored_scales.png';

const optionsImages = {
	goal: {
		lose_weight: iconScales,
		body_tone_up: iconLift,
		love_myself: iconHeart,
		gain_muscles: iconMuscle,
		gain_muscles_female: iconMuscle,
		gain_flexibility: iconFlexFemale,
		gain_build_endurance: iconRunFemale,
		gain_healthier_life: iconOk,
		male: {
			lose_weight: iconScales,
			body_tone_up: iconLift,
			love_myself: iconHeart,
			gain_muscles: iconMuscle,
			gain_muscles_female: iconMuscle,
			gain_flexibility: iconFlexMale,
			gain_build_endurance: iconRunMale,
			gain_healthier_life: iconOk
		}
	},
	goalB: {
		lose_weight: iconScales,
		body_tone_up: iconLift,
		love_myself: iconHeart,
		gain_muscles: iconMuscle,
		gain_muscles_female: iconMuscle,
		gain_flexibility: iconFlexFemale,
		gain_build_endurance: iconRunFemale,
		gain_healthier_life: iconOk,
		male: {
			lose_weight: iconScales,
			body_tone_up: iconLift,
			love_myself: iconHeart,
			gain_muscles: iconMuscle,
			gain_muscles_female: iconMuscle,
			gain_flexibility: iconFlexMale,
			gain_build_endurance: iconRunMale,
			gain_healthier_life: iconOk
		}
	},
	colored_options_start_screen: {
		body_tone_up: coloredToneUp,
		love_myself: coloredHeart,
		gain_muscles: coloredGain,
		lose_weight: coloredScales,
	},
	goal_three: {
		feel_better: iconScales,
		improve_health: iconHeart,
		both: iconMuscle,
	},
	activities_preferences: {
		fitness: iconHome,
		walking: iconWalking,
		running: iconRuning,
		yoga: iconYoga,
		dance: iconDance,
		gym: iconLift
	},
	age: {
		'18-29': iconScales,
		'30-39': iconLift,
		'40-49': iconHeart,
		'50-59+': iconMuscle
	},
	zones_start_screen: {
		abs: abs,
		glutes: glutes,
		armpits: armpits,
		thighs: thighs
	},
	diet_type: {
		all: iconMeat,
		vegetarian: iconVeget,
		vegan: iconVegan,
		keto: iconCheese
	},
	current_level: {
		beginner: iconSmile,
		intermediate: smileGlasses,
		advanced: superhero
	},
	devices: {
		bands: fitness,
		barbell,
		treadmill,
		dumbells,
		none: cross
	},
	previous_fails: {},
	zones: {
		arm_back: armBack,
		abs_core: absCore,
		legs_glutes: legsGlutes,
		male: {
			arm_back: armBackMale,
			abs_core: absCoreMale,
			legs_glutes: legsGlutesMale
		}
	},
	motivation: {
		tips: iconTips,
		body_changes: iconOk,
		training_progress: iconTraining,
		comunity: iconGlobe,
		coachs: iconReceipt,
		apple_rings: iconTrafficLight
	},
	focus: {
		physical: iconMuscle,
		diet: appleGreen,
		sleep: iconMoon,
		mindful: iconYoga
	},
	frequency: {},
	duration: {
		minimum: time1,
		normal: time2,
		maximum: time0,
		undefined: time3
	},
	sleep: {
		extra_low: sleep,
		low: bed,
		normal: sleep2,
		maximum: superhero
	},
	water: {
		extra_low: coffee,
		low: two,
		normal: ok,
		maximum: horns
	},
	motivation_rate: {
		low: thinking,
		normal: horns,
		maximum: fire
	},
	life_changes: {
		ideal_weight: cross,
		more_confident: relievedFace,
		much_happier: laugh,
		new_person: starsEyes
	},
	last_time_ideal_weight: {
		year_ago: thinking,
		'1_2_years_ago': frowningFace,
		'3+_years_ago': facepalm,
		never: cross
	},
	nutrition_approaches: {
		fasting: iconPlateAndForks,
		calorie_counting: iconReceiptTwo,
		nutrient_counting: iconCurryRice,
		water_traking: iconDrop,
		none: cross
	},
	physicall_active: {
		extra_low: iconComputer,
		low: iconYogaTwo,
		normal: iconWalkingTwo,
		maximum: iconRunning
	},
	exercises_time: {
		morning: iconSun,
		day: iconRocket,
		evening: iconMoon,
		not_sure: iconDontNow
	},
	diseases: {
		diabetes: iconPill,
		astma: iconBreath,
		joint: iconJoint,
		none: iconSmile
	},
	health_issues: {},
	body_type: {
		apple,
		pear,
		square,
		trapezoid,
		triangle,
		hourglass,
		unknown,
		male: {
			apple: appleMale,
			pear: pearMale,
			square: squareMale,
			trapezoid: trapezoidMale,
			triangle: triangleMale,
			unknown: unknownMale
		}
	},
	medications: {
		vitamins: iconPill,
		hormones: iconTestTube,
		antibiotics: iconDna,
		other: iconAlembic,
		none: iconSmile
	},
	emotional_eating: {
		yes: trueImg,
		no: falseImg
	},
	successfully_lost_weight: {
		yes: trueImg,
		no: falseImg
	},
	noise_free: {
		yes: trueImg,
		no: falseImg
	}
};

export default optionsImages;
